import { useContext } from 'react';
import { FileUploadEffectsContext } from '../Context';

export const useFileUploadEffects = () => {
  const effects = useContext(FileUploadEffectsContext);

  return effects;
};

export default useFileUploadEffects;